import * as z from "zod";

export const CropTypeDtoSchema = z
    .object({
        id: z.number(),
        code: z.string().trim(),
        agents: z.boolean(),
        create_at: z.string().trim().optional(),
        update_at: z.string().trim().optional(),
    })
    .readonly();

export type CropTypeDto = z.output<typeof CropTypeDtoSchema>;

export const CropTypesDtoSchema = z.array(CropTypeDtoSchema).readonly();

export type CropTypesDto = z.output<typeof CropTypesDtoSchema>;
